import { useState } from "react";
import Simple from "../../../Components/InputFields/Simple";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import Back from "./Back";

export default function ContainerForgotPWEmail({
  text,
  onContinue,
  onBack,
  onInputChange,
  loading,
  error,
}) {
  const logoSrc = document.documentElement.classList.contains("dark")
    ? LogoWhite10
    : LogoBlue;
  const [email, setEmail] = useState("");
  const [emailRequired, setEmailRequired] = useState(false);
  const [emailBlur, setEmailBlur] = useState(false);
  const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (email.trim() === "") {
      setEmailRequired(true);
      return;
    }
    if (!emailValid) {
      setEmailBlur(true);
      return;
    }
    onContinue(email.trim());
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setEmailRequired(false);
    onInputChange?.();
  };

  return (
    <div className="w-full max-w-md bg-zi-bg2-light dark:bg-zi-bg2-dark rounded-2xl p-5 m-4 gap-7 flex flex-col border border-zi-blue-light">
      <div className="flex flex-col gap-2 justify-center items-center">
        <img src={logoSrc} alt="لوگو" className="w-14" />
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          {text}
        </h1>
        <Back onClick={onBack} />
      </div>
      <div>
        <form
          className="flex flex-col gap-5"
          noValidate
          onSubmit={handleSubmit}
        >
          <Simple
            placeholder="آدرس ایمیل"
            type="email"
            id="forgot-password-email"
            formValue={email}
            formOnChange={handleEmailChange}
            emailBlur={emailBlur}
            setEmailBlur={setEmailBlur}
            emailValid={emailValid}
          />
          <GradientBlue
            type="submit"
            value="ارسال کد از طریق ایمیل"
            isLoader={loading}
            disabled={loading}
          />
        </form>
        {emailRequired && (
          <p className="text-red-500 text-sm font-extralight mt-1">
            لطفا ایمیل خود را وارد کنید
          </p>
        )}
        {!emailRequired && emailBlur && !emailValid && (
          <p className="text-red-500 text-sm font-extralight mt-1">
            لطفا یک ایمیل معتبر وارد کنید
          </p>
        )}
        {error && (
          <p className="text-red-500 text-sm font-extralight mt-1">{error}</p>
        )}
      </div>
    </div>
  );
}
